/** P32 (Feb 27, 2026) — Constants and pricing tables for the Rhinobill claim page.
 *
 *  Extracted from the 1,672-line single-file claim page so the
 *  configuration that drives validation + UI is independently
 *  inspectable + testable.
 */

// Ohio DODD HCPCS codes — when selected, the claim is priced via the CODB
// matrix using the patient's county-derived tier (per OAC 5123-9-14). Keep
// this list in sync with backend/config/dodd_rates.py.
export const DODD_CODES = new Set([
  'HCBTR', 'HMPCR', 'HMPCC', 'NMMOD', 'NMTPM', 'TRMOD', 'TRANS', 'NMTPT', 'BSR', 'MAR',
]);
export const isDoddCode = (code) => Boolean(code && DODD_CODES.has(code));

// CMS-1500 Place of Service codes used in the EDI 837P SV1 segment.
export const PLACE_OF_SERVICE_OPTIONS = [
  { value: '12', label: '12 — Home' },
  { value: '11', label: '11 — Office' },
  { value: '99', label: '99 — Other' },
];

// ODM hard cap on single-encounter billing (OAC 5160-12-05).
export const MAX_VISIT_DURATION_HOURS = 16;

// Fallback used when the backend modifier catalog endpoint is
// unreachable. Object-shaped so callers can index by code:
// `modifierCatalog['U1']`.
export const FALLBACK_MODIFIER_CATALOG = {
  U1: { code: 'U1', description: 'Infusion Therapy', auto_rule: null },
  U2: { code: 'U2', description: '2nd visit (same day)', auto_rule: 'visit_2_same_day' },
  U3: { code: 'U3', description: '3rd+ visit (same day)', auto_rule: 'visit_3plus_same_day' },
  U4: { code: 'U4', description: 'Visit > 12 hours', auto_rule: 'duration_gt_12h' },
  U6: { code: 'U6', description: 'Adult PDN', auto_rule: null },
  U7: { code: 'U7', description: 'Increased Home Health Services', auto_rule: null },
  HQ: { code: 'HQ', description: 'Group Visit', auto_rule: null },
};

// HCPCS-variant catalog mirrors backend/config/modifier_catalog.HCPCS_VARIANTS.
// For codes like T1000 that bill differently for RN vs LPN, the Service
// dropdown shows the variant key (T1000-RN / T1000-LPN) and the backend
// auto-applies the always-on modifier (TD for RN, TE for LPN).
export const HCPCS_VARIANTS_FRONTEND = {
  T1000: [
    { key: 'T1000-RN',  label: 'T1000 - (PDN - RN)',  always_apply: ['TD'] },
    { key: 'T1000-LPN', label: 'T1000 - (PDN - LPN)', always_apply: ['TE'] },
  ],
};

// Codes that are flat-rate assessments — units locked to 1, no chips.
export const ASSESSMENT_CODES_FRONTEND = { T1001: 1 };
